import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "./DoctorWebsite.css";
import { LanguageContext } from "./LanguageContext";

export default function İletişim() {
  const { lang, toggleLanguage } = useContext(LanguageContext);

  const content = {
    tr: {
      appointment: "Randevu Al",
      aboutme: "Hakkımda",
      media: "Medya",
      opinion: "Görüşler",
      faq: "İletişim",
      socials: "Bana Ulaş",
      address: "Adres:",
      phone: "Telefon:",
    },
    en: {
      appointment: "Make an Appointment",
      aboutme: "About Me",
      media: "Media",
      opinion: "Opinions",
      faq: "Contact",
      socials: "Contact Me",
      address: "Address:",
      phone: "Phone:",
    },
  };
  if (!content[lang]) return null;
  return (
    <>
      <header className="main-header">
        <div className="header-left">
          <Link to="/">
            <img src="/logo.png" alt="Logo" className="logo" />
          </Link>
        </div>

        <div className="header-center">
          <nav className="nav-links">
            <a href="/#about">{content[lang].aboutme}</a>
            <a href="/medya" className="text-blue-600 hover:underline">
              {content[lang].media}
            </a>
            <a href="/reviews">{content[lang].opinion}</a>
            <a href="/contact">{content[lang].faq}</a>
          </nav>
          <div className="underline" />
        </div>

        <div className="header-right">
          <button onClick={toggleLanguage} className="lang-btn">
            {lang === "tr" ? "EN" : "TR"}
          </button>
          <a
            href="https://www.medicana.com.tr/online-randevu?d=6g8OSll_QHs=&h=eJTRa8B9u7U=&b=O9z2njYFPJY="
            target="_blank"
            rel="noopener noreferrer"
            className="appointment-btn"
          >
            {content[lang].appointment}
          </a>
        </div>
      </header>
      <h1 className="page-title">{content[lang].faq}</h1>
      <div className="contact-page">
        <div className="contact-card">
          <div className="map-container">
            <iframe
              title="Medicana Zincirlikuyu Hastanesi"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3007.8872574150823!2d29.015278000000006!3d41.071456999999974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab6446c863909%3A0x5fa5f58341667495!2sMedicana%20Zincirlikuyu%20Hastanesi!5e0!3m2!1sen!2str!4v1754674492882!5m2!1sen!2str"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="contact-details">
            <p>
              <strong>{content[lang].address}</strong> Barbaros Bulvarı No:123,
              Beşiktaş / İstanbul
            </p>
            <p>
              <strong>{content[lang].phone}</strong>+90 (212) 970 7970
            </p>
          </div>
        </div>
      </div>
      <section className="contact-section">
        <h4 className="contact-title">{content[lang].socials}</h4>
        <div className="contact-icons">
          <a
            href="mailto:cenesize@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-envelope"></i>
          </a>
          <a
            href="https://instagram.com/dremrecenesiz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://bulutklinik.com/dr-ogr-uyesi-emre-cenesiz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              border="0"
              alt="bulut klinik"
              src="bulut_klinik.png"
              width="20"
              height="20"
            />
          </a>
          <a
            href="https://www.doktorsitesi.com/dr-ogr-uyesi-emre-cenesiz/cocuk-sagligi-ve-hastaliklari/istanbul"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              border="0"
              alt="doktor sitesi"
              src="doktor_sitesi.png"
              width="20"
              height="20"
            />
          </a>
        </div>
      </section>
    </>
  );
}
